import styled from 'foundations-theming/utils';
// Invert Horizontal and Vetical are optional props that can be passed in and
// are based on whether the drag is being inverted in theose directions
export default styled.div.withConfig({
  displayName: "ResizeableThumbnailOutline"
})(["border:3px solid ", ";cursor:pointer;height:", ";width:", ";opacity:", ";position:absolute;left:", ";right:", ";top:", ";bottom:", ";"], ({
  theme
}) => theme.color['fill-accent-blue-hover'], ({
  height
}) => height ? `${height}px` : '100%', ({
  width
}) => width ? `${width}px` : '100%', ({
  selected
}) => selected ? 1 : 0, ({
  invertHorizontal
}) => invertHorizontal ? null : '0px', ({
  invertHorizontal
}) => invertHorizontal ? '0px' : null, ({
  invertVertical
}) => invertVertical ? null : '0px', ({
  invertVertical
}) => invertVertical ? '0px' : null);